import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const PinterestAd = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12690"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12690)">
          <rect
            x="-3"
            width="121"
            height="112"
            rx="5.09677"
            fill="#BFCDFF"
          />
          <rect
            x="10.0664"
            y="28.0625"
            width="26.4395"
            height="43.004"
            rx="4.61895"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="18.0176"
            y="30.7703"
            width="11.239"
            height="1.27419"
            rx="0.637097"
            fill="#1E1E1E"
          />
          <rect
            x="19.6228"
            y="38.2561"
            width="57.6573"
            height="50.6492"
            rx="0.796371"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="19.145"
            y="62.625"
            width="58.6129"
            height="1.27419"
            fill="#1E1E1E"
          />
          <rect
            x="19.145"
            y="42.875"
            width="58.6129"
            height="0.955645"
            fill="#1E1E1E"
          />
          <rect
            x="23.6047"
            y="53.0686"
            width="49.0564"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="23.6047"
            y="57.5283"
            width="38.8629"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <rect
            x="31.25"
            y="47.9718"
            width="12.1048"
            height="2.54839"
            rx="0.637097"
            fill="#8C8C8C"
          />
          <circle
            cx="26.1531"
            cy="48.6089"
            r="2.54839"
            fill="#8C8C8C"
          />
          <circle
            cx="68.5201"
            cy="40.6452"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="71.7056"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="74.8909"
            cy="40.6451"
            r="0.955645"
            fill="#FFB700"
          />
          <circle
            cx="52.9113"
            cy="70.9074"
            r="1.91129"
            fill="#0C5CEF"
          />
          <path
            d="M45.4549 70.0025C45.5184 69.9133 45.6509 69.9133 45.7144 70.0025L56.2655 84.831C56.3405 84.9365 56.2651 85.0827 56.1357 85.0827H35.0336C34.9042 85.0827 34.8288 84.9365 34.9038 84.831L45.4549 70.0025Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M54.6934 75.0875C54.757 74.9995 54.8881 74.9995 54.9517 75.0875L55.3341 74.8113L54.9517 75.0875L61.9879 84.83C62.064 84.9354 61.9887 85.0826 61.8588 85.0826H47.7863C47.6564 85.0826 47.5811 84.9354 47.6572 84.83L54.6934 75.0875Z"
            fill="#DDEBDB"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            fill="white"
          />
          <rect
            x="72.502"
            y="20.4174"
            width="33.4476"
            height="33.4476"
            rx="16.7238"
            stroke="#1E1E1E"
            strokeWidth="0.955645"
          />
          <path
            d="M80.6978 37.1411C80.6978 40.6332 82.7977 43.6331 85.8025 44.952C85.7785 44.3566 85.7983 43.6417 85.951 42.9938C86.1149 42.3015 87.0483 38.3469 87.0483 38.3469C87.0483 38.3469 86.7758 37.8024 86.7758 36.9976C86.7758 35.7338 87.5083 34.79 88.4206 34.79C89.1963 34.79 89.571 35.3726 89.571 36.0703C89.571 36.8501 89.0737 38.0164 88.8179 39.0967C88.6042 40.0014 89.2715 40.7392 90.1639 40.7392C91.7797 40.7392 92.868 38.664 92.868 36.2051C92.868 34.3361 91.6091 32.9371 89.3194 32.9371C86.7325 32.9371 85.1209 34.8663 85.1209 37.0211C85.1209 37.7641 85.3399 38.2881 85.6831 38.6938C85.8408 38.8801 85.8627 38.9551 85.8057 39.1691C85.7647 39.326 85.6708 39.7038 85.6319 39.8535C85.5751 40.0695 85.4001 40.1467 85.2049 40.0669C84.0134 39.5805 83.4584 38.2757 83.4584 36.8089C83.4584 34.3864 85.5016 31.4816 89.5535 31.4816C92.8094 31.4816 94.9524 33.8377 94.9524 36.3668C94.9524 39.7121 93.0925 42.2114 90.3509 42.2114C89.4302 42.2114 88.5641 41.7137 88.2675 41.1484C88.2675 41.1484 87.7724 43.1133 87.6675 43.4927C87.4867 44.1502 87.1328 44.8074 86.8092 45.3196C87.5762 45.546 88.3864 45.6693 89.2261 45.6693C93.9355 45.6693 97.7539 41.8512 97.7539 37.1411C97.7539 32.4313 93.9355 28.6132 89.2261 28.6132C84.5163 28.6132 80.6978 32.4313 80.6978 37.1411Z"
            fill="#CB1F27"
          />
        </g>
      </SvgIcon>
    );
  })
);
PinterestAd.displayName = 'PinterestAd';
